export const mobility_annual_report = [
  {
    id: 1,
    name: 'wcmd-annual-report-24-25-english',
    summary: 'shortsummary/wcmd-annual-report-24-25-english.html',
    link: 'wcmd-annual-report-24-25-english.pdf',
    audio_en: 'audio/en/wcmd-annual-report-24-25-english_en.mp3',
    audio_af: 'audio/af/wcmd-annual-report-24-25-english_af.mp3',
    audio_xh: 'audio/xh/wcmd-annual-report-24-25-english_xh.mp3'
  }
];